<template>
  <div class="period-configuration">
    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Blackout
      </PmwHeading>

      <PmwParagraph class="form--subtitle" size="paragraph-40">
        Dias em que esta tarifa não será exibida para o usuário.
      </PmwParagraph>
    </div>

    <div class="form--row">
      <!-- INPUT ESTILO RANGE DE PERIODO DE HOSPEAGEM - BLACKOUT -->
      <PmwFormDatepicker
        v-model="blackoutDate"
        :range="true"
        label="Período de blackout"
        placeholder="01/01/2023 - 01/01/2024"
        size="large"
        class="form--input__datepicker"
      />

      <!-- BOTÃO DE ADICIONAR DATA -->
      <PmwButton
        :hasIcon="true"
        :disabled="!blackoutDate"
        variation="blue-100"
        class="form--button"
        size="large"
        @click="addDate($event)"
      >
        Adicionar
      </PmwButton>
    </div>

    <!-- CHIP COM PERÍODOS ADICIONADOS -->
    <div
      v-if="
        fluctuationData.periodosBlackout &&
          fluctuationData.periodosBlackout.length >= 1
      "
      class="form--row__small"
    >
      <Chip
        v-for="(period, i) in fluctuationData.periodosBlackout"
        :key="`period-chip-${i}`"
        class="form--input__period"
        cols="2"
        close
        @close="removeDate(i)"
      >
        {{ formatDate(new Date(period.dataInicio)) }} -
        {{ formatDate(new Date(period.dataFim)) }}
      </Chip>
    </div>

    <PmwParagraph class="form--blackout-observation" size="paragraph-40">
      Obs: A noite final do período selecionado não será bloqueada.
    </PmwParagraph>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFormDatepicker from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormDatepicker'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Chip from '@/components/_base/patterns/Chip'
import { formatDate } from '@/helpers/date'

export default {
  name: 'PeriodBlackout',
  components: {
    PmwHeading,
    PmwParagraph,
    PmwFormDatepicker,
    PmwButton,
    Chip
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      blackoutDate: null
    }
  },

  created() {
    if (this.fluctuationData.periodosBlackout) {
      this.orderBlackoutPeriod()
    }
  },

  methods: {
    formatDate: formatDate,

    /** Adiciona chip com a data */
    addDate() {
      if (!this.fluctuationData.periodosBlackout)
        this.fluctuationData.periodosBlackout = []

      /** Ajusta os valores dos dados de data */
      this.fluctuationData.periodosBlackout.push({
        dataInicio: this.blackoutDate.start,
        dataFim: this.blackoutDate.end
      })

      this.orderBlackoutPeriod()

      this.blackoutDate = ''
    },

    /** Remove as Datas */
    removeDate(index) {
      this.fluctuationData.periodosBlackout.splice(index, 1)
    },

    orderBlackoutPeriod() {
      this.fluctuationData.periodosBlackout.sort((a, b) => {
        const dateA = new Date(a.dataFim)
        const dateB = new Date(b.dataFim)
        return dateA - dateB
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--subtitle {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    line-height: 21px;
  }

  &--blackout-observation {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    margin-top: -16px;
  }

  &--input {
    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight('weight-medium');
      }
      .form-field--label-wrapper {
        line-height: 21px;
        margin-bottom: 3px;
      }
      .pmw-input {
        background: $white;
      }
      .pmw-input--clear {
        z-index: 0;
      }
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-input--field {
        background: $pmw-white;

        &:focus {
          border-color: $pmw-blue;
        }
      }

      .pmw-input__disabled {
        input {
          background: pmw-colors('grey-20');
          color: $pmw-gray-darker;
        }
      }

      .pmw-custom-tooltip {
        line-height: 18px;
      }
    }

    &__datepicker {
      margin-right: 10px;

      ::v-deep {
        .pmw-input--field:focus {
          border-color: pmw-colors(blue-100);
        }

        .pmw-input--clear {
          color: pmw-colors(blue-100);
        }
      }
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;

    &__small {
      max-width: 500px;
      gap: 0px;
      margin-top: -15px;
      margin-bottom: 32px;
    }
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }
}
</style>
